import gql from 'graphql-tag'

import { NegotiationResponseFragment } from '@/graphql/fragments/purchase'

export const mutation = gql`
  ${NegotiationResponseFragment}
  mutation insertNegotiationResponse($fields: purchase_negotiation_response_insert_input!) {
    record: insert_purchase_negotiation_response_one(object: $fields) {
      ...NegotiationResponse
    }
  }
`

export default mutation
